/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
} from './PaymentState';

/**
 * 
 * @export
 * @interface CompletedPaymentDto
 */
export interface CompletedPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof CompletedPaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof CompletedPaymentDto
     */
    bookingReference: string;
    /**
     * 
     * @type {PaymentState}
     * @memberof CompletedPaymentDto
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof CompletedPaymentDto
     */
    paymentMethod: PaymentMethodDto;
    /**
     * 
     * @type {number}
     * @memberof CompletedPaymentDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof CompletedPaymentDto
     */
    refundedAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof CompletedPaymentDto
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof CompletedPaymentDto
     */
    deviceId: string;
}

/**
 * Check if a given object implements the CompletedPaymentDto interface.
 */
export function instanceOfCompletedPaymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentReference" in value;
    isInstance = isInstance && "bookingReference" in value;
    isInstance = isInstance && "paymentState" in value;
    isInstance = isInstance && "paymentMethod" in value;
    isInstance = isInstance && "deviceId" in value;

    return isInstance;
}

export function CompletedPaymentDtoFromJSON(json: any): CompletedPaymentDto {
    return CompletedPaymentDtoFromJSONTyped(json, false);
}

export function CompletedPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentReference': json['paymentReference'],
        'bookingReference': json['bookingReference'],
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentMethod': PaymentMethodDtoFromJSON(json['paymentMethod']),
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'refundedAmount': !exists(json, 'refundedAmount') ? undefined : json['refundedAmount'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'deviceId': json['deviceId'],
    };
}

export function CompletedPaymentDtoToJSON(value?: CompletedPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentReference': value.paymentReference,
        'bookingReference': value.bookingReference,
        'paymentState': PaymentStateToJSON(value.paymentState),
        'paymentMethod': PaymentMethodDtoToJSON(value.paymentMethod),
        'amount': value.amount,
        'refundedAmount': value.refundedAmount,
        'created': value.created,
        'deviceId': value.deviceId,
    };
}

